import { render, staticRenderFns } from "./ExportLink.vue?vue&type=template&id=f5a2fd0a&scoped=true"
import script from "./ExportLink.vue?vue&type=script&lang=js"
export * from "./ExportLink.vue?vue&type=script&lang=js"
import style0 from "./ExportLink.vue?vue&type=style&index=0&id=f5a2fd0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a2fd0a",
  null
  
)

export default component.exports